import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { FileText } from 'lucide-react';

const CompanyNewsCard = ({ symbol, news }) => {
  if (!news?.length) return null;
  return (
    <Card className="mb-8" data-testid="research-news-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <FileText className="text-purple-600" size={20} />
          Recent News for {symbol}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3 max-h-96 overflow-y-auto">
          {news.slice(0, 8).map((item, idx) => (
            <div
              key={item.url || `${item.title}-${idx}`}
              className="border-b border-gray-100 pb-3 last:border-0"
              data-testid={`research-news-item-${idx}`}
            >
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-gray-900 hover:text-purple-600 line-clamp-1"
              >
                {item.title}
              </a>
              <p className="text-sm text-gray-500 line-clamp-2 mt-1">{item.summary}</p>
              <div className="flex items-center gap-2 mt-1 text-xs text-gray-400">
                <span>{item.source}</span>
                <span>•</span>
                <span>{item.datetime ? new Date(item.datetime).toLocaleDateString() : ''}</span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default CompanyNewsCard;
